import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerService } from '../../services/partner.service';

@Component({
  selector: 'app-student-profile-page',
  templateUrl: './student-profile-page.component.html',
  styleUrls: ['./student-profile-page.component.scss']
})
export class StudentProfilePageComponent implements OnInit {
  puid: string = ''; // Stores PUID from the URL
  partnerLogo: string = ''; // Stores Partner Logo URL

  isMobileMenuOpen = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private partnerService: PartnerService
  ) {

  }

  ngOnInit(): void {
    const puid = this.activatedRoute.snapshot.paramMap.get('puid');
    this.puid = puid

    if (puid) {
      this.fetchPartnerLogo(this.puid);
    }

  }

  // Add mobile menu methods
  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  closeMobileMenu(): void {
    this.isMobileMenuOpen = false;
  }


  fetchPartnerLogo(puid?: string): void {
    this.partnerService.getPartnerLogo(puid).then(
      (response) => {
        if (response?.data?.company?.logo) {
          this.partnerLogo = response.data.company.logo;
        } else {
          console.warn("No partner logo found for PUID:", puid);
        }
      }
    ).catch(
      (error) => {
        console.error('Error fetching partner logo:', error);
      }
    );
  }
}
